// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2vNeN","content":"LayoutSettings_content__UESKe"};